import { render, staticRenderFns } from "./QuotaSale.vue?vue&type=template&id=0e17bdcb&scoped=true"
import script from "./QuotaSale.vue?vue&type=script&lang=js"
export * from "./QuotaSale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e17bdcb",
  null
  
)

export default component.exports